export default __webpack_public_path__ + "static/media/driver_vehicle.f5b515d7.svg";